<template>
    <div class="wakenovel-page" v-if="bookCon">
        <div class="img-div">
            <img class="rand_pic" :src="bookCon.iconUrlLarge" alt="My CEO Stepbrother Kissed me">
        </div>
        <div class="pageTitle">{{bookCon.name}}</div>
        <div class="author">By {{bookCon.author.name}}</div>
        <div class="clickNum flexible">
            <div class="item flexible flex jc-center">
                <img src="@/static/wakenovel/ic_view@2x.png" class="ic_view"/>
                <div class="item-data">
                    <div class="data-num">{{bookCon.clickNum>1000?(bookCon.clickNum / 1000).toFixed(1)+'k': bookCon.clickNum}}</div>
                    <div class="data-name">Views</div>
                </div>
            </div>
            <div class="item flexible flex jc-center">
                <img src="@/static/wakenovel/ic_collects@2x.png" class="ic_collects"/>
                <div class="item-data">
                    <div class="data-num">{{bookCon.collectNum>1000?(bookCon.collectNum / 1000).toFixed(1)+'k': bookCon.collectNum}}</div>
                    <div class="data-name">Collects</div>
                </div>
            </div>
        </div>
        <div id="copycontent" class="book-con" v-html="bookCon.excitingChapter">
           {{bookCon.excitingChapter}}
        </div>
        <div class="download-img">
            <img src="@/static/wakenovel/logo.png"/>
        </div>
        <div class="center" v-if="bookCon != ''">
            <a class="download-btn" href="https://play.google.com/store/apps/details?id=com.wakenovel.book">Download the APP to read more</a>
            <!--            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('ios')" href="javascript:void(0);"><img src="../../assets/account/btn_iphone.png"/></a>-->
        </div>
    </div>
</template>

<script>
    import "utils/lib/rem1";
    import { bookdark } from "apiurl/book";
    export default {
        name: "",
        data () {
            return {
                bookCon: null,
            }
        },
        mounted () {
            this.getCon()
        },
        methods: {
            async getCon () {
                let res = await bookdark({bookId: this.$route.params.id, pageNum: 1, pageSize: 5});
                if (res.success) {
                    let num = Math.floor(Math.random()*5)
                    console.log(num)
                    this.bookCon = res.data.list[num]
                    this.bookName = res.data.noticeTitle
                    this.$route.meta.title = this.bookCon.name
                    console.log(this.$route.meta.title)
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .wakenovel-page{
        width: 100%;
        min-height: 100vh;
        display: inline-block;
        height: auto;
        background: #fff;
        padding-bottom: 0.3rem;
        .img-div{
            width: 2.07rem;
            height: 2.8rem;
            text-align: center;
            margin: auto;
            margin-top: 0.15rem;
            img{
                width: 2.07rem;
                height: 2.8rem;
                border-radius: 0.15rem;
            }
        }
        .pageTitle{
            width: 3rem;
            margin: auto;
            font-size: 0.15rem;
            margin-top: 0.2rem;
            font-weight: bold;
            color: #333333;
            text-align: center;
            line-height: 0.2rem;
        }
        .author{
            font-size: 0.12rem;
            text-align: center;
            margin-top: 0.05rem;
            color: #898989;
        }
        .clickNum{
            margin-top: 0.15rem;
            .ic_view{
                width: 0.15rem;
                height: 0.1rem;
            }
            .ic_collects{
                width: 0.15rem;
                height: 0.15rem;
            }
            .data-num{
                font-size: 0.15rem;
                font-weight: bold;
                color: #333333;
                margin-left: 0.05rem;
            }
            .data-name{
                font-size: 0.11rem;
                color: #A3A6AF;
                font-weight: 400;
                margin-left: 0.05rem;
            }
        }
        .book-con{
            margin: 0.15rem;
            font-size: 0.14rem;
            color: #373743;
            line-height: 0.26rem;
            font-weight: 400;
            white-space: pre-wrap
        }
        .download-img{
            width: 1.34rem;
            height: 0.48rem;
            margin:  0.3rem auto;
            img{
                width: 1.34rem;
                height: 0.48rem;
            }
        }
        .center{
            width: 100%;
            position: fixed;
            bottom: 0.1rem;
            .download-btn {
                display: block;
                width: 2.9rem;
                height: 0.39rem;
                background: linear-gradient(180deg, #E6FF55 0%, #C2E300 100%);
                border-radius: 0.2rem;
                line-height: 0.39rem;
                text-align: center;
                color: #000000;
                font-weight: 500;
                font-size: 0.15rem;
                margin: auto;
            }
        }
    }

</style>
